import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Button, Card, Icon, Link, Text } from "~/components-shared";
import { usePostHog } from "posthog-js/react";
import Markdown from "~/components/Markdown";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { RoutesEnum, StatusStateEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import insightReportsActionCreators from "~/store/insightReports/actions";
import toastsActionCreators from "~/store/toasts/actions";
import insightReportSelectors from "~/store/insightReports/selectors";
const StyledButton = styled(Button)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
const InsightsHighlightCard = _ref => {
  let {
    reportId,
    highlight,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const posthog = usePostHog();
  const dispatch = useDispatch();
  const status = useSelector(insightReportSelectors.getStatusByHighlightDismiss(highlight.id));
  const handleTopicClick = id => {
    history.push(RoutesEnum.TOPIC.replace(":topicId", id));
    posthog.capture(`Insights Highlight – View Topic`, {
      topicId: id
    });
  };
  const handleDismiss = id => {
    dispatch(insightReportsActionCreators.dismissHighlightStarted(reportId, id, _ref2 => {
      let {
        data
      } = _ref2;
      if (data) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("InsightsHighlightCard.highlightDismissed"),
          timeout: 10000
        }));
      }
    }));
    posthog.capture(`Insights Highlight – Dismiss`, {
      highlightId: id
    });
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      p: 5,
      pr: 10
    }
  }, rest), /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    weight: "light",
    lineHeight: 6,
    text: highlight.text,
    style: {
      flexGrow: 1
    },
    linkColor: "primary"
  }), highlight.topic ? /*#__PURE__*/React.createElement(Link, {
    onClick: () => handleTopicClick(highlight.topic?.id || ""),
    weight: "semiBold",
    color: "primary",
    s: {
      mt: 2
    }
  }, highlight.topic?.name) : /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    color: ""
  }, "Topic removed"), /*#__PURE__*/React.createElement(StyledButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("common.actions.dismiss"),
    onClick: () => handleDismiss(highlight.id),
    color: "transparent",
    rounded: true,
    outline: false,
    loading: status === StatusStateEnum.LOADING,
    s: {
      p: 2,
      mx: 0.5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "cross",
    color: colors.text.primary,
    display: "block"
  })));
};
export default InsightsHighlightCard;